export interface IPage<TItems> {
  totalItems: number;
  pageSize: number;
  currentPage: number;
  numberOfPages: number;
  items: TItems[];
}

export function getEmptyPage<TItem>(pageNo = 0, pageSize = 0): IPage<TItem> {
  return {
    currentPage: pageNo,
    pageSize: pageSize,
    numberOfPages: 0,
    totalItems: 0,
    items: [],
  };
}
